import { EventShim, EventTagerShim } from "../EventTaget/index";
import mutationObserver from "../mutationObserver/index";
import intersectionObserver, { IntersectionHelper } from "../intersectionObserver/index";
import eventCatch from "../eventCatch/index";
import { deepFindLog, isIntersecting, now, fixIosClick, getAttrFrom, findExtraLog, getClickPositionParams, debounce, isUndefined } from "../utils/index";
import { Heatmap } from "../heatmap/index";
const logAttributeMap = {
  "data-log-view": "data-log-view",
  "data-log-click": "data-log-click",
  "data-log-extra": "data-log-extra",
  "data-log-render": "data-log-render",
  "data-log-outview": "data-log-outview",
  "data-log-view-stay": "data-log-view-stay"
};
export class LogEvent {
  constructor(target, logPath, info, wil) {
    this.type = info.type;
    Object.assign(this, info);
    this.log = Object.assign({}, ...[...logPath].reverse());
    this.path = logPath;
    this.target = target;
    this.time = now();
    this.wil = wil;
  }

}

class WilIntersectionObserverEvent extends EventShim {
  constructor(type, event) {
    super(type);
    this.from = event;
  }

}

class WilMutationObserverEvent extends EventShim {
  constructor(type, event) {
    super(type);
    this.from = event;
  }

}

class WilClickEventEvent extends EventShim {
  constructor(type, event) {
    super(type);
    this.from = event;
  }

}

class WilLogEvent extends EventShim {
  constructor(type, event) {
    super(type);
    this.from = event;
  }

}

class WilEventTaget extends EventTagerShim {
  constructor(fn, option = {}) {
    super();

    this.focusCallBack = () => {
      this.updateStayTime();
    };

    this.blurCallBack = () => {
      this.dispatchStayLog();
    };

    this.options = option;
    const {
      intersectionOptions = {}
    } = option;
    this.observedElements = [];
    this.inViewElement = new Set();
    this.stayWeakMap = new WeakMap();
    this.viewOutWeakSet = new WeakSet();
    this.viewWeakSet = new WeakSet();
    this.outViewWeakSet = new WeakSet();
    this.config = Object.assign({}, logAttributeMap, option.attribute);

    if (!option.disableView) {
      const prev = e => {
        this.dispatchEvent(new WilIntersectionObserverEvent("intersectionObserver", e));
      };

      const intersectionObserverCallbacks = [prev];
      this.intersectionObserver = intersectionObserver(intersectionObserverCallbacks, intersectionOptions);
      this.mutationObserver = mutationObserver(e => {
        this.dispatchEvent(new WilMutationObserverEvent("mutationObserver", e));
      });
    }

    const intersectionObserverDebounced = this.options.intersectionObserverDebounced;

    if (!isUndefined(intersectionObserverDebounced)) {
      const {
        wait = 0,
        immediate = false
      } = intersectionObserverDebounced;
      this.intersectionObserveElements = debounce(observer => this._intersectionObserveElements(observer), wait, immediate);
    }

    this.init(fn);

    if (option.heatmapConfig) {
      new Heatmap(fn, option.heatmapConfig, this);
    }
  }

  init(fn) {
    eventCatch(event => {
      this.dispatchEvent(new WilClickEventEvent("clickEvent", event));
    });
    this.addEventListener("intersectionObserver", event => {
      this.handleIntersectionObserver(event);
    });
    this.addEventListener("mutationObserver", event => {
      this.handleMutationObserver(event);
    });
    this.addEventListener("clickEvent", event => {
      this.handleClickEvent(event);
    });
    this.listenLogEvent(fn);
    this.intersectionObserveElements(this.intersectionObserver);
    this.fixIOSSafari();
  }

  genarateDispatchEvent(target, log, params) {
    this.dispatchEvent(new WilLogEvent("logEvent", new LogEvent(target, log, params, this)));
  }

  handleIntersectionObserver(event) {
    const e = event.from;
    const {
      target
    } = e;

    if (isIntersecting(e) && !this.viewWeakSet.has(target)) {
      if (this.dispatchViewLog(target)) {
        try {
          const config = JSON.parse(getAttrFrom(e, 'data-log-view-config') || '{}');

          if (!config['repeated']) {
            this.viewWeakSet.add(target);
          }
        } catch (e) {
          this.viewWeakSet.add(target);
        }
      }
    }

    const attributeName = this.config["data-log-view-stay"];
    const attributeExtraName = this.config["data-log-extra"];

    if (isIntersecting(e) && target.hasAttribute(attributeName)) {
      this.stayWeakMap.set(target, now());
      this.inViewElement.add(target);
    }

    if (!isIntersecting(e) && target.hasAttribute(attributeName)) {
      const startTime = this.stayWeakMap.get(target);
      this.inViewElement.delete(target);

      if (startTime) {
        const logJson = deepFindLog(target, attributeName, attributeExtraName);

        if (logJson) {
          this.genarateDispatchEvent(target, logJson, {
            type: "view-stay",
            duration: now() - startTime,
            startTime,
            endTime: now()
          });
        }
      }
    }

    if (true) {
      const attributeName = this.config["data-log-outview"];
      const attributeExtraName = this.config["data-log-extra"];

      if (isIntersecting(e) && target.hasAttribute(attributeName)) {
        this.viewOutWeakSet.add(target);
      }

      if (!isIntersecting(e) && !this.outViewWeakSet.has(target) && this.viewOutWeakSet.has(target)) {
        const log = deepFindLog(target, attributeName, attributeExtraName);

        if (log) {
          this.viewOutWeakSet.delete(target);
          this.outViewWeakSet.add(target);
          this.genarateDispatchEvent(target, log, {
            type: "outview"
          });
        }
      }
    }
  }

  fixIOSSafari() {
    if (document.body) {
      fixIosClick();
    } else {
      document.addEventListener("DOMContentLoaded", () => {
        fixIosClick();
      });
    }
  }

  intersectionObserveElements(intersectionObserver) {
    this._intersectionObserveElements(intersectionObserver);
  }

  _intersectionObserveElements(intersectionObserver) {
    console.log('intersectionObserveElements!!!');
    const aboutViewAttributeName = ["data-log-view", "data-log-view-stay", "data-log-outview"];
    aboutViewAttributeName.map(key => this.config[key]).filter(i => !!i).map(attributeName => document.querySelectorAll(`[${attributeName}]`)).forEach(eles => {
      for (let i = 0; i < eles.length; i++) {
        if (intersectionObserver) {
          intersectionObserver.observe(eles[i]);
        }
      }
    });
  }

  handleMutationObserver(event) {
    const e = event.from;
    const attributeName = this.config["data-log-render"];
    const extraAttribute = this.config["data-log-extra"];

    if (e.type === "childList" && e.addedNodes && attributeName) {
      const addedNodes = e.addedNodes;

      for (let i = 0; i < addedNodes.length; i++) {
        const currentNode = addedNodes.item ? addedNodes.item(i) : addedNodes[i];

        if (currentNode && currentNode.nodeType === 1 && currentNode instanceof Element) {
          const items = currentNode.querySelectorAll(`[${attributeName}]`);

          if (currentNode.hasAttribute(attributeName)) {
            const log = deepFindLog(currentNode, attributeName, extraAttribute);

            if (log) {
              this.genarateDispatchEvent(currentNode, log, {
                type: "render"
              });
            }
          }

          for (let i = 0; i < items.length; i++) {
            const log = deepFindLog(items[i], attributeName, extraAttribute);

            if (log) {
              this.genarateDispatchEvent(items[i], log, {
                type: "render"
              });
            }
          }
        }
      }
    }

    this.intersectionObserveElements(this.intersectionObserver);
    this.fixIOSSafari();
  }

  handleClickEvent(e) {
    const event = e.from;
    this.handleMouseEvent(event);
  }

  handleMouseEvent(e) {
    const targetElement = e.target;

    if (targetElement && (targetElement instanceof HTMLElement || targetElement instanceof SVGElement) && targetElement.nodeType === 1 && e.type == "click") {
      const attributeName = this.config["data-log-click"];
      const attributeExtraName = this.config["data-log-extra"];
      const log = deepFindLog(targetElement, attributeName, attributeExtraName);

      if (log !== null) {
        const params = getClickPositionParams(e, log);
        params ? log.unshift(Object.assign({}, params)) : log;
        this.genarateDispatchEvent(targetElement, log, {
          type: "click"
        });
      }
    }
  }

  listenLogEvent(fn) {
    this.addEventListener("logEvent", e => {
      const event = e.from;
      fn(event);
    });
  }

  updateStayTime() {
    this.inViewElement.forEach(ele => {
      this.stayWeakMap.set(ele, now());
    });
  }

  dispatchViewLog(target) {
    const attributeName = this.config["data-log-view"];
    const attributeExtraName = this.config["data-log-extra"];
    const log = deepFindLog(target, attributeName, attributeExtraName);

    if (log) {
      this.genarateDispatchEvent(target, log, {
        type: "view"
      });
      return true;
    }

    return false;
  }

  dispatchStayLog() {
    this.inViewElement.forEach(ele => {
      const startTime = this.stayWeakMap.get(ele);

      if (startTime) {
        const attributeName = this.config["data-log-view-stay"];
        const attributeExtraName = this.config["data-log-extra"];
        const logJson = deepFindLog(ele, attributeName, attributeExtraName);

        if (logJson) {
          this.genarateDispatchEvent(ele, logJson, {
            type: "view-stay",
            duration: now() - startTime,
            startTime,
            endTime: now()
          });
        }
      }
    });
  }

}

export { WilEventTaget, deepFindLog, IntersectionHelper };

function Wil(fn, option = {}) {
  return new WilEventTaget(fn, option);
}

Wil.utils = {
  findExtraLog
};
export default Wil;